/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Oficina Automóvel em Chaves | Roady Centro-Auto Chaves',
        description: 'Oficina Roady em Chaves: revisões, pneus, mudança de óleo, travões e diagnóstico. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'oficina Chaves, pneus Chaves, revisão automóvel Chaves, mecânica Chaves, roady Chaves',
        canonical: 'https://roadychaves.com/'
    },
    pneus: {
        title: 'Pneus em Chaves | Roady Centro-Auto Chaves',
        description: 'Pneus para o seu carro em Chaves. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus Chaves, comprar pneus Chaves, montagem pneus',
        canonical: 'https://roadychaves.com/loja/pneus'
    },

    // Workshop (Services Overview)
    workshop: {
        title: 'Serviços de Oficina em Chaves | Roady Centro-Auto Chaves',
        description: 'Revisão, pneus, óleo, travões, alinhamento e diagnóstico em Chaves. Veja todos os serviços do Roady Chaves e peça orçamento sem compromisso.',
        keywords: 'serviços automóvel Chaves, oficina Chaves, mecânica Chaves',
        canonical: 'https://roadychaves.com/oficina'
    },

    // Service Details
    'revisoes-roady': {
        title: 'Revisão Automóvel em Chaves | Roady Centro-Auto Chaves',
        description: 'Revisão completa em Chaves, sem perder a garantia do seu carro. Veja o que está incluído e peça orçamento sem compromisso.',
        keywords: 'revisão automóvel Chaves, revisão carro Chaves, manutenção automóvel',
        canonical: 'https://roadychaves.com/oficina/revisoes-roady'
    },
    'alinhamento': {
        title: 'Alinhamento de Direção no Chaves — Roady Centro-Auto Chaves',
        description: 'Alinhamento profissional em Chaves. Menos desgaste nos pneus, condução segura e precisa. Peça orçamento sem compromisso.',
        keywords: 'alinhamento Chaves, alinhamento direção Chaves, geometria Chaves',
        canonical: 'https://roadychaves.com/oficina/alinhamento'
    },
    'teste-diagnostico': {
        title: 'Diagnóstico Eletrónico no Chaves — Roady Centro-Auto Chaves',
        description: 'Diagnóstico eletrónico completo para todas as marcas. Identificação rápida e precisa de avarias. Roady Centro-Auto Chaves.',
        keywords: 'diagnóstico automóvel Chaves, teste eletrónico Chaves, diagnóstico carro',
        canonical: 'https://roadychaves.com/oficina/teste-diagnostico'
    },
    'travoes': {
        title: 'Serviço de Travões no Chaves — Roady Centro-Auto Chaves',
        description: 'Substituição de pastilhas e discos de travão no Chaves. Segurança garantida com profissionais Roady.',
        keywords: 'travões Chaves, pastilhas travão Chaves, discos travão Chaves',
        canonical: 'https://roadychaves.com/oficina/travoes'
    },
    'amortecedores': {
        title: 'Amortecedores no Chaves — Roady Centro-Auto Chaves | Troca e Revisão',
        description: 'Troca e revisão de amortecedores no Chaves. Estabilidade e segurança com serviço Roady certificado.',
        keywords: 'amortecedores Chaves, suspensão Chaves, troca amortecedores',
        canonical: 'https://roadychaves.com/oficina/amortecedores'
    },
    'inspecao': {
        title: 'Pré-Inspeção Automóvel no Chaves — Roady Centro-Auto Chaves',
        description: 'Prepare o seu carro para a inspeção com o serviço Roady no Chaves. Verificação completa e rápida.',
        keywords: 'pré-inspeção Chaves, inspeção automóvel Chaves, preparação inspeção',
        canonical: 'https://roadychaves.com/oficina/inspecao'
    },
    'mecanica-geral': {
        title: 'Mecânica Automóvel no Chaves — Roady Centro-Auto Chaves',
        description: 'Mecânica automóvel completa no Chaves. Reparações e manutenção com técnicos especializados Roady.',
        keywords: 'mecânica geral Chaves, reparação automóvel Chaves, mecânico Chaves',
        canonical: 'https://roadychaves.com/oficina/mecanica-geral'
    },
    'ar-condicionado': {
        title: 'Carregamento de Ar Condicionado Auto em Chaves | Roady',
        description: 'Carregamento e manutenção do ar condicionado do seu carro em Chaves. Saiba quando é preciso e peça orçamento sem compromisso.',
        keywords: 'ar condicionado auto Chaves, carga AC Chaves, reparação AC automóvel',
        canonical: 'https://roadychaves.com/oficina/ar-condicionado'
    },
    'baterias': {
        title: 'Baterias Automóvel no Chaves — Roady Centro-Auto Chaves',
        description: 'Teste e substituição de baterias automóvel no Chaves. Instalação com garantia Roady.',
        keywords: 'baterias auto Chaves, bateria carro Chaves, substituição bateria',
        canonical: 'https://roadychaves.com/oficina/baterias'
    },
    'restauro-farois': {
        title: 'Restauro de Faróis no Chaves — Roady Centro-Auto Chaves',
        description: 'Restauro profissional de faróis automóvel. Melhore a visibilidade e segurança. Roady Chaves.',
        keywords: 'restauro faróis Chaves, polimento faróis Chaves, recuperação faróis',
        canonical: 'https://roadychaves.com/oficina/restauro-farois'
    },
    'lavagem': {
        title: 'Lavagem Auto no Chaves — Roady Centro-Auto Chaves',
        description: 'Serviços de lavagem automóvel completos no Chaves. Interior e exterior com profissionais Roady.',
        keywords: 'lavagem auto Chaves, limpeza carro Chaves, lavagem completa',
        canonical: 'https://roadychaves.com/oficina/lavagem'
    },
    'servicos-oficina': {
        title: 'Plano de Serviços Oficina — Roady Centro-Auto Chaves',
        description: 'Planos de serviços e manutenção para a sua oficina. Soluções completas Roady no Chaves.',
        keywords: 'plano serviços Chaves, manutenção oficina Chaves',
        canonical: 'https://roadychaves.com/oficina/servicos-oficina'
    },

    // Store & Categories
    store: {
        title: 'Loja Auto no Chaves — Roady Centro-Auto Chaves | Peças e Acessórios',
        description: 'Óleos, acessórios, produtos auto, limpeza e manutenção. Loja Roady Chaves.',
        keywords: 'loja auto Chaves, peças automóvel Chaves, acessórios auto Chaves',
        canonical: 'https://roadychaves.com/loja'
    },
    'loja-eletricidade': {
        title: 'Eletricidade Automóvel — Loja Roady Chaves',
        description: 'Componentes elétricos, baterias e acessórios elétricos para automóvel. Roady Chaves.',
        keywords: 'eletricidade auto Chaves, componentes elétricos carro',
        canonical: 'https://roadychaves.com/loja/eletricidade'
    },
    'loja-equipamento-interior': {
        title: 'Equipamento Interior Auto — Loja Roady Chaves',
        description: 'Acessórios e equipamentos para interior do automóvel. Qualidade garantida Roady.',
        keywords: 'equipamento interior auto, acessórios interior carro Chaves',
        canonical: 'https://roadychaves.com/loja/equipamento-interior'
    },
    'loja-equipamento-exterior': {
        title: 'Equipamento Exterior Auto — Loja Roady Chaves',
        description: 'Acessórios e equipamentos para exterior do automóvel. Loja Roady Chaves.',
        keywords: 'equipamento exterior auto, acessórios exterior carro Chaves',
        canonical: 'https://roadychaves.com/loja/equipamento-exterior'
    },
    'loja-lubrificantes': {
        title: 'Lubrificantes e Óleos Auto — Loja Roady Chaves',
        description: 'Óleos motor, lubrificantes e produtos de manutenção. Marcas de confiança no Roady Chaves.',
        keywords: 'óleo motor Chaves, lubrificantes auto Chaves',
        canonical: 'https://roadychaves.com/loja/lubrificantes'
    },
    'loja-manutencao': {
        title: 'Produtos de Manutenção Auto — Loja Roady Chaves',
        description: 'Produtos de manutenção e cuidado automóvel. Roady Chaves.',
        keywords: 'produtos manutenção auto, cuidado automóvel Chaves',
        canonical: 'https://roadychaves.com/loja/manutencao'
    },
    'loja-pecas-tecnicas': {
        title: 'Peças Técnicas Auto — Loja Roady Chaves',
        description: 'Peças técnicas e componentes para automóvel. Qualidade garantida Roady.',
        keywords: 'peças técnicas auto Chaves, componentes carro',
        canonical: 'https://roadychaves.com/loja/pecas-tecnicas'
    },
    'loja-pneus': {
        title: 'Pneus em Chaves | Roady Centro-Auto Chaves',
        description: 'Pneus para o seu carro em Chaves. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus Chaves, comprar pneus Chaves, montagem pneus',
        canonical: 'https://roadychaves.com/loja/pneus'
    },
    'loja-som-multimedia-navegacao': {
        title: 'Som, Multimédia e Navegação — Loja Roady Chaves',
        description: 'Sistemas de som, multimédia e navegação GPS para automóvel. Roady Chaves.',
        keywords: 'som auto Chaves, GPS carro Chaves, multimédia automóvel',
        canonical: 'https://roadychaves.com/loja/som-multimedia-navegacao'
    },
    'loja-ferramentas': {
        title: 'Ferramentas Auto — Loja Roady Chaves',
        description: 'Ferramentas profissionais e acessórios para manutenção automóvel. Roady Chaves.',
        keywords: 'ferramentas auto Chaves, ferramentas mecânica',
        canonical: 'https://roadychaves.com/loja/ferramentas'
    },

    // Other Pages
    budget: {
        title: 'Peça Orçamento Automóvel em Chaves | Roady Chaves',
        description: 'Peça orçamento para revisão, pneus, travões ou mudança de óleo no Roady Chaves. Diga-nos o que o carro precisa e respondemos com um valor claro.',
        keywords: 'orçamento auto Chaves, pedir orçamento oficina Chaves',
        canonical: 'https://roadychaves.com/orcamento'
    },
    mobility: {
        title: 'Mobilidade Urbana Chaves — Roady Centro-Auto Chaves',
        description: 'Bicicletas e trotinetes elétricas no Chaves. Assistência e apoio Roady.',
        keywords: 'mobilidade Chaves, bicicletas elétricas Chaves, trotinetes Chaves',
        canonical: 'https://roadychaves.com/mobilidade'
    },
    recruitment: {
        title: 'Recrutamento — Roady Centro-Auto Chaves',
        description: 'Junte-se à equipa Roady Centro-Auto Chaves. Procuramos talento para o setor automóvel. Envie candidatura.',
        keywords: 'emprego Chaves, trabalho oficina Chaves, recrutamento roady',
        canonical: 'https://roadychaves.com/recrutamento'
    },
    contact: {
        title: 'Contactos e Horário | Roady Centro-Auto Chaves',
        description: 'Morada, horário, telefone e WhatsApp do Roady Centro-Auto Chaves. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'contacto roady Chaves, telefone oficina Chaves, morada roady',
        canonical: 'https://roadychaves.com/contacto'
    },
    wecall: {
        title: 'Ligamos-lhe — Roady Centro-Auto Chaves',
        description: 'Deixe os seus dados e ligamos-lhe. Atendimento personalizado Roady Chaves.',
        keywords: 'contacto roady Chaves, ligação gratuita',
        canonical: 'https://roadychaves.com/ligamos'
    },
    wishlist: {
        title: 'Lista de Desejos — Roady Centro-Auto Chaves',
        description: 'Guarde os seus produtos favoritos na lista de desejos. Loja Roady Chaves.',
        canonical: 'https://roadychaves.com/lista-desejos'
    },

    // Legal Pages
    cookies: {
        title: 'Política de Cookies — Roady Centro-Auto Chaves',
        description: 'Política de cookies do website Roady Centro-Auto Chaves. Saiba como utilizamos cookies.',
        canonical: 'https://roadychaves.com/politica-cookies'
    },
    privacy: {
        title: 'Política de Privacidade — Roady Centro-Auto Chaves',
        description: 'Política de privacidade e proteção de dados do Roady Centro-Auto Chaves.',
        canonical: 'https://roadychaves.com/politica-privacidade'
    },
    terms: {
        title: 'Termos e Condições — Roady Centro-Auto Chaves',
        description: 'Termos e condições de utilização do website Roady Centro-Auto Chaves.',
        canonical: 'https://roadychaves.com/termos-condicoes'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.workshop;
};

/**
 * Get SEO data for a store category page
 */
export const getStoreCategorySEO = (categorySlug: string): PageSEO => {
    const key = `loja-${categorySlug}`;
    return seoData[key] || seoData.store;
};

